export enum TitleType {
  BIG = 'big',
  MEDIUM = 'medium',
  SMALL = 'small',
  MOBILE_RESPONSIVE = 'mobileResponsive',
}
